/**
 * @generated SignedSource<<bd087b492e24aa999e657a1ddbea40e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NotificationNotificationType = "CONDITIONSACCEPTED" | "CONFIRMACCOUNT" | "DEPRECATED" | "DEPRECATED_80" | "EDITMODEREMINDER" | "EVALUATIONREMINDER" | "EVALUATIONSESSIONREMINDER" | "EVALUATIONSESSIONSTART" | "EXPIRATIONREMINDERTOUNANSWEREDREFERENCEVALIDATION" | "INVITETOCONCEPTEVALUATION" | "INVITETOPITCHEVALUATION" | "INVITETOREFERENCEVALIDATION" | "INVITETORFQ" | "NEWANNOUNCEMENT" | "NEWANSWERSTOQUESTIONS" | "NEWCLIENTCALLBACKWASPOSTED" | "NEWORGANIZATIONACCOUNT" | "NEWPROJECTCREATEDRFP" | "NEWPROJECTCREATEDRFQ" | "NEWPROJECTREQUEST" | "NEWPROJECTSTATUS" | "NEWPROJECTSTATUSRFQ" | "NEWPROJECTSUBMITTEDRFP" | "NEWPROJECTSUBMITTEDRFQ" | "NEWPROPOSALSUBMITTEDRFP" | "NEWPROPOSALSUBMITTEDRFQ" | "NEWQUESTIONS" | "NEWRATESSUBMITTED" | "NEWSUPPORTQUESTION" | "NEWUSERACCOUNTACTIVATED" | "NEWUSERACCOUNTCREATED" | "OVERDUEPROJECTS" | "PARTICIPATIONCANCELLEDBYVENDOR" | "PITCHEVALUATIONREMINDER" | "PITCHINVITATION" | "PITCHINVITATIONACCEPTED" | "PITCHINVITATIONDECLINED" | "PROJECTAWARDINGDUE" | "PROJECTAWARDINGDUEDATEREMINDER" | "PROJECTINVITATIONACCEPTEDRFQ" | "PROJECTREQUESTREJECTED" | "PROPOSALACCEPTED" | "PROPOSALAWARDINGCLIENTINTERNAL" | "PROPOSALAWARDINGDUE" | "PROPOSALAWARDINGDUEDATEREMINDER" | "PROPOSALAWARDINGTOSUPPLIER" | "PROPOSALCANCELLATIONBYSUPPLIER" | "PROPOSALDELETED" | "PROPOSALDISMISSED" | "PROPOSALDUEDATEREMINDER" | "PROPOSALINVITATION" | "PROPOSALLOSTMESSAGETOSUPPLIER" | "PROPOSALPARTICIPATIONCONFIRMATION" | "PROPOSALREVISIONREQUESTED" | "RATEREVISIONREQUESTED" | "RATESCONFIRMED" | "RATESREJECTED" | "RECOVERPASSWORD" | "REFERENCECANCELLED" | "REFERENCECONFIRMED" | "REFERENCEEXPIRED" | "REFERENCEPIN" | "REFERENCEREJECTED" | "REMINDERFORCONFIRMATIONOFRFQ" | "REMINDERFORCONFIRMATIONOFRRFP" | "REMINDERFORINVITETORFP" | "REMINDERFORINVITETORFQ" | "REMINDERFORPROPOSALDUEDATE" | "REMINDERTOUNANSWEREDQUESTIONS" | "REMINDERTOUNANSWEREDREFERENCEVALIDATION" | "REQUESTNEWPROPOSAL" | "SECONDREMINDERTOUNANSWEREDREFERENCEVALIDATION" | "SUCCESSFULPROPOSALSUBMISSION" | "SUCCESSFULRATECARDPROPOSALSUBMISSION" | "SUPPLIERCONFIRMSTNCS" | "SUPPLIERDISMISSEDFROMRFP" | "SUPPLIERREJECTSTNCS" | "SURVEYINVITE" | "TIMELINECHANGE" | "USERASSIGNEDTORFP" | "USERASSIGNEDTORFQ" | "%future added value";
export type NotificationPopupComponentMarkAllAsReadMutation$variables = {};
export type NotificationPopupComponentMarkAllAsReadMutation$data = {
  readonly markAllNotificationsAsRead: {
    readonly notifications: ReadonlyArray<{
      readonly context: any | null;
      readonly created: any;
      readonly id: string;
      readonly notificationType: NotificationNotificationType;
      readonly unread: boolean;
    } | null> | null;
  } | null;
};
export type NotificationPopupComponentMarkAllAsReadMutation = {
  response: NotificationPopupComponentMarkAllAsReadMutation$data;
  variables: NotificationPopupComponentMarkAllAsReadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "input",
        "value": {}
      }
    ],
    "concreteType": "MarkAllNotificationsAsReadPayload",
    "kind": "LinkedField",
    "name": "markAllNotificationsAsRead",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationNode",
        "kind": "LinkedField",
        "name": "notifications",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notificationType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "created",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unread",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "context",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "markAllNotificationsAsRead(input:{})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationPopupComponentMarkAllAsReadMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NotificationPopupComponentMarkAllAsReadMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "ed50e94c9f2ebd69f06049e4e8d3b553",
    "id": null,
    "metadata": {},
    "name": "NotificationPopupComponentMarkAllAsReadMutation",
    "operationKind": "mutation",
    "text": "mutation NotificationPopupComponentMarkAllAsReadMutation {\n  markAllNotificationsAsRead(input: {}) {\n    notifications {\n      id\n      notificationType\n      created\n      unread\n      context\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f50b60734663416926445761b0b0f383";

export default node;
